import { render, staticRenderFns } from "./tbr-edm-detail.vue?vue&type=template&id=9a776fca&scoped=true&"
import script from "./tbr-edm-detail.vue?vue&type=script&lang=js&"
export * from "./tbr-edm-detail.vue?vue&type=script&lang=js&"
import style0 from "./tbr-edm-detail.vue?vue&type=style&index=0&id=9a776fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a776fca",
  null
  
)

export default component.exports